import VDatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'DatepickerRange',
  props: ['value', 'disabled'],
  data () {
    return {
      content: (this.value ? this.value : { range: { start: null, end: null } })
    }
  },
  components: {
    VDatePicker
  },
  computed: {
    localeConfig () {
      return { id: this.$i18n.locale, firstDayOfWeek: 2, masks: { L: 'YYYY-MM-DD' } }
    }
  },
  methods: {
    getContentDates (val) {
      const res = { start: null, end: null };
      if (val && val.start) {
        res.start = this.$options.filters.formatDate(val.start, 'YYYY-MM-DD', true)
      }
      if (this.content && this.content.end) {
        res.end = this.$options.filters.formatDate(val.end, 'YYYY-MM-DD', true)
      }
      return res;
    },
    formatInputValue (val) {
      if (val) {
        const tmpVal = this.getContentDates(val);
        return this.$options.filters.formatDateRange({ fromDate: tmpVal.start, toDate: tmpVal.end }, this.$t('general.dateFormat'), null, '');
      }
      return '';
    },
    clearSearch () {
      this.content = { range: { start: null, end: null } };
      this.updateValue();
    },
    updateValue () {
      this.$emit('input', this.getContentDates(this.content));
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.content = (val || { range: { start: null, end: null } });
      }
    }
  }
}
